module.exports = __webpack_public_path__ + "img/vertical_7_6_9016.646b5885.png";